<template src='./SeguimientoPaciente.html'></template>

<script>
import DatosInicioSeguimiento from "../DatosInicioSeguimiento/DatosInicioSeguimiento";
import CuestionarioSeguimiento from "../CuestionarioSeguimiento/CuestionarioSeguimiento";
import Marcaciones from "../../Marcaciones/Marcaciones";
import { crearFormulario } from "../../../apiService/request/CrudFormulario";
import { serverBus } from "../../../main";
import { actualizarCuestionario } from "../../../apiService/request/CrudSeguimiento";
import { consultarListaCuestionario } from "../../../apiService/request/CrudSeguimiento";
import { crearCuestionario } from "../../../apiService/request/CrudSeguimiento";
import { consultarEstructuraCuestionarioPorId } from "../../../apiService/request/CrudSeguimiento";
import { consultarMarcaciones } from "../../../apiService/request/CrudSeguimiento";
import { reemplazarCaracteresEspeciales } from "../../../js/metodos_comunes";
import { agregarNotaEncuentro } from "../../../apiService/request/CrudEncuentro";
import { actualizarEstadoOrdenes } from "../../../apiService/request/CrudOrdenes";
import mixinActualizarValidarVariables from "../../../js/mixins/mixinActualizarValidarVariables";
import SubirArchivo from "../../SubirArchivo/SubirArchivo";
import { consultarTextoResumen } from "../../../apiService/request/CrudEncuentro";
import moment from "moment";
import { prerrequisitos } from "../../../apiService/request/CrudEncuentro.js";

export default {
  data() {
    return {
      texto_introductorio: null,
      MostrarBoton: true,
      formularioSeguimiento: {},
      idFormularioSeguimiento: "",
      banderaEncuesta: false,
      preguntasEncuestas: [],
      listaCuestionarios: [],
      informacionMarcaciones: [],
      keyFormulario: "",
      paciente: {},
      nuevaNota: "",
      notas: "",
      nombreFormularioCreado: null
    };
  },
  mixins: [mixinActualizarValidarVariables],
  filters: {
    moment: function(date, format) {
      var fecha = isNaN(date) ? date : Number(date);
      return moment(fecha).format(format);
    }
  },
  created() {
    this.funcionPrerrequisitos();
  },
  mounted() {
    this.paciente = {
      documento: this.$store.getters.getCedulaPaciente,
      nombre: this.$store.getters.getNombrePaciente
    };
    serverBus.$on("crearCuestionario", (nombre_formulario, tipo) => {
      this.preguntasEncuestas = [];
      this.formularioSeguimiento = [];
      this.keyFormulario = "";
      this.$store.dispatch('setNombreFormulario', null);
      this.$store.dispatch('setIdFormulario', null);
      this.crearCuestionarioSeguimiento(nombre_formulario, tipo);
    });
    // serverBus.$on(
    //   "actualizarEncuesta",
    //   (id_formulario, arrayVariablesActualizar, key) => {
    //     this.filtroVariablesObligatoriasDiligenciadas(key);
    //     // this.actualizarCuestionarioIndividual(id_formulario, arrayVariablesActualizar,key);
    //   }
    // );
    serverBus.$on("consultarCuestionarioExistente",( id_formulario, tipo,tipo_formulario )=> {
      this.preguntasEncuestas = [];
      this.formularioSeguimiento = [];
      // this.consultarEsquemaFormularioSeguimiento(id_formulario);
      this.consultarEsquemaCuestionarioSeguimiento(id_formulario,tipo,tipo_formulario);
      // this.consultarCuestionarioIndividualExistente(id_formulario, arrayVariablesActualizar);
    });
    serverBus.$on("formularioActualizadoExitosamenteMomento", resp => {
      console.log(
        `SeguimientoPaciente idFormulario: ${this.$store.getters.getId}`
      );
      this.preguntasEncuestas = [];
      this.formularioSeleccionado = ""
      this.consultarListaCuestionarioGeneral();
      // this.consultarCuestionarioIndividualExistente(id_formulario, arrayVariablesActualizar);
    });
  },
  beforeDestroy() {
    serverBus.$off("actualizarEncuesta");
    serverBus.$off("crearCuestionario");
    serverBus.$off("consultarCuestionarioExistente");
    this.$store.dispatch("setIdFormulario", null);
    this.$store.dispatch("setVariablesFormularios", []);
    this.$store.dispatch("setVariablesActualizadas", []);
    this.$store.dispatch("setNombreFormulario", null);
    this.$store.dispatch("setCampoIngresado", null);
    this.$store.dispatch("setNombreCampo", null);
  },
  components: {
    DatosInicioSeguimiento,
    CuestionarioSeguimiento,
    Marcaciones,
    SubirArchivo
  },
  props: {
    deshabilitado: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async funcionPrerrequisitos() {
      try{
        await prerrequisitos(this.$store.getters.getColeccion, Number(this.$store.getters.getCedulaPaciente), this.$store.state.provider_email, this.$store.getters.getId);        
      }finally{
        this.consultarMarcacionesPacientes();
        this.consultarListaCuestionarioGeneral();
        this.$store.dispatch("setVariablesFormularios", []);
        this.textoResumen();
      }
    },
    /**
     * Método que pasa la orden al estado "factura"
     */
    async facturarOrden(idOrden) {
      this.$store.dispatch("setCargando", true);
      try {
        await actualizarEstadoOrdenes(
          "factura",
          this.$store.state.provider_email,
          idOrden
        );
      } catch (err) {
        console.log(err);
        this.$store.dispatch("setCargando", false);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
    //FUNCIONES ASYNC PARA CREAR REGISTROS
    async textoResumen() {
      try {
        const respuesta = await consultarTextoResumen(
          this.$store.getters.getId,
          "seguimientos"
        );
        this.notas = respuesta.data.data;
      } catch (err) {}
      finally {
      this.$store.dispatch("setCargando", false);
      }
    },
    async agregarNuevaNota() {
      this.$store.dispatch("setCargando", true);
      try {
        const respuesta = await agregarNotaEncuentro(
          this.$store.getters.getId,
          this.nuevaNota,
          this.$store.state.provider_email,
          "seguimientos"
        );
        this.$store.dispatch("cambiarEstadoModal", true);
        this.$store.dispatch("cambiarMensajeModal", respuesta);
      } finally {
        this.nuevaNota = "";
        this.textoResumen();
      }
    },
    async enviarSeguimiento() {
      this.$store.dispatch("setMensajeChatBox", "terminar");
      // await this.facturarOrden(ID_DE_LA_ORDEN); ID_DE_LA_ORDEN pendiente con Steben
    },
    // async crearFormularioSeguimiento(nombre_formulario) {
    //   try {
    //     this.formularioSeguimiento = [];
    //     const respuesta = await crearFormulario(
    //       nombre_formulario,
    //       this.$store.state.provider_email,
    //       "momento1",
    //       parseInt(this.$store.getters.getCedulaPaciente),
    //       this.$store.getters.getId
    //     );
    //     this.idFormularioSeguimiento = respuesta.data.data.docId;
    //     this.consultarListaCuestionarioGeneral();
    //     this.consultarEsquemaCuestionarioSeguimiento(respuesta.data.data.docId,tipo);
    //     // this.consultarEsquemaFormularioSeguimiento(respuesta.data.data.docId);
    //     this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
    //   } catch (err) {}
    // },
    async crearCuestionarioSeguimiento(nombre_formulario, tipo) {
      try {
        const respuesta = await crearCuestionario(
          reemplazarCaracteresEspeciales(nombre_formulario),
          parseInt(this.$store.getters.getCedulaPaciente),
          this.$store.state.provider_email,
          this.$store.getters.getId,
          this.$store.getters.getColeccion,
          tipo
        );
        this.$store.dispatch("setIdFormulario", respuesta.data.data.docId);
        this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
         this.nombreFormularioCreado = nombre_formulario;
        this.consultarListaCuestionarioGeneral();
        this.consultarEsquemaCuestionarioSeguimiento(
          respuesta.data.data.docId,
          tipo,
          nombre_formulario
        );
      } catch (err) {
        console.log(err);
      }
    },
    //FUNCIONES ASYNC PARA CONSULTAR REGISTROS
    // async consultarEsquemaFormularioSeguimiento(formulario_id) {
    //   try {
    //     this.$store.dispatch("setCargando", true);
    //     const respuesta = await consultarEstructuraCuestionarioPorId(
    //       formulario_id,
    //       "formularios"
    //     );
    //     this.formularioSeguimiento = respuesta.data.data;
    //     this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
    //     this.$store.dispatch(
    //       "setVariablesFormularios",
    //       respuesta.data.data.variables
    //     );
    //     this.$store.dispatch("setNombreFormulario", respuesta.data.data.key);
    //     this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
    //     this.$store.dispatch("setCargando", false);
    //   } catch (err) {
    //     this.$store.dispatch("setCargando", false);
    //   }
    // },
    async consultarEsquemaCuestionarioSeguimiento(formulario_id,tipo,nombre_formulario) {
      try {
        this.$store.dispatch("setConsultarFormulario", '');
        const respuesta = await consultarEstructuraCuestionarioPorId(
          formulario_id,
          tipo,
          nombre_formulario
        );
        if (respuesta.status && respuesta.status == 200) {
          if (respuesta && respuesta.data && respuesta.data.data && respuesta.data.data.texto_introductorio) {
            this.texto_introductorio = respuesta.data.data.texto_introductorio;
          } else {
            this.texto_introductorio = null;
          }
          this.preguntasEncuestas = respuesta.data.data.variables;
          this.keyFormulario = respuesta.data.data.key;
          this.$store.dispatch("setBanderaFormularioCreadoPanel", true);
          this.$store.dispatch("setVariablesFormularios",respuesta.data.data.variables);
          this.$store.dispatch("setNombreFormulario", respuesta.data.data.key);
          this.$store.dispatch("setColeccion", respuesta.data.data.coleccion);
          // this.consultarListaCuestionarioGeneral()
          // this.preguntasEncuestas=respuesta
         
        }
      } catch (err) {}
    },
    async consultarListaCuestionarioGeneral() {
      try {
        const respuesta = await consultarListaCuestionario(
          this.$store.getters.getNombreEvento,
          this.$store.getters.getId
        );
        this.listaCuestionarios = respuesta.data.data.dataCuestionarios;
        this.listaCuestionarios.sort(function (a, b) {
          if (a.nombre.toUpperCase() > b.nombre.toUpperCase()) {
            return 1;
          }
          if (a.nombre.toUpperCase() < b.nombre.toUpperCase()) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        console.log("listaCuestionarios 3 ", this.listaCuestionarios);
        this.$emit("datosCargados");
      } catch (err) {}
    },
    async consultarMarcacionesPacientes() {
      try {
        const respuesta = await consultarMarcaciones(
          parseInt(this.$store.getters.getCedulaPaciente)
        );
        this.informacionMarcaciones = respuesta.data.data;
      } catch (err) {}
    },
    //FUNCIONES ASYNC PARA ACTUALIZAR REGISTROS
    async actualizarCuestionarioIndividual(
      id_formulario,
      key,
      arrayVariablesActualizar
    ) {
      if (id_formulario == "") {
        id_formulario = this.$store.getters.getIdFormulario;
      }
      try {
        const respuesta = await actualizarCuestionario(
          id_formulario,
          key,
          arrayVariablesActualizar,
          this.$store.state.provider_email
        );
        // this.preguntasEncuestas=[]
        // this.consultarListaCuestionarioGeneral()
        // this.arrayVariablesActualizar=[]
        // this.flechaArriba = true;
        // this.valorSeleccionadoRadio = [];
        // this.mostrarRespuestaFormulario = false;
      } catch (err) {}
    }
  }
};
</script>
<style lang="scss" scoped src='./SeguimientoPaciente.scss'>
</style>


// WEBPACK FOOTER //
// src/components/Seguimiento/SeguimientoPaciente/SeguimientoPaciente.vue